module.exports = __webpack_public_path__ + "img/bubles_desk.1c90ad7e.gif";